export default {
  id: null,
  visitName: null,
  active: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/visittypemodel.js